import { NotFound } from "@quortex/front-common"
import { type DefaultGenerics, Navigate, type Route } from "@tanstack/react-location"
import { lazy } from "react"

// Misc
const IngestApp = lazy(() =>
  import("@/pages/IngestApp").then(module => ({ default: module.IngestApp }))
)

// Input
const InputList = lazy(() => import("@/pages/InputList/InputList"))
const InputView = lazy(() => import("@/pages/InputView/InputView"))
const InputOverviewTab = lazy(() => import("@/pages/InputView/OverviewTab"))
const InputConfigurationTab = lazy(() => import("@/pages/InputView/ConfigurationTab"))
const InputStreamEdit = lazy(() => import("@/pages/InputView/InputStreamEdit"))
const StreamSwitchTab = lazy(() => import("@/pages/InputView/StreamSwitchTab"))

//EventLog
const EventLog = lazy(() => import("@/pages/EventLog/EventLog"))

export const ingestRoutes: Route<DefaultGenerics>[] = [
  {
    path: "ingest",
    element: <IngestApp />,
    children: [
      {
        path: "/",
        element: <Navigate replace to="inputs" />
      },
      {
        path: "inputs/:inputUuid",
        element: <InputView />,
        children: [
          {
            path: "overview",
            element: <InputOverviewTab />
          },
          {
            path: "switch",
            element: <StreamSwitchTab />
          },
          {
            path: "configuration",
            element: <InputConfigurationTab />,
            children: [
              {
                path: ":streamUuid",
                element: <InputStreamEdit />
              }
            ]
          }
        ]
      },
      {
        element: <InputList />,
        path: "inputs"
      },
      {
        element: <EventLog />,
        path: "event-log"
      },
      {
        element: <NotFound />
      }
    ]
  },
  {
    path: "home",
    element: <Navigate to="../ingest" />
  }
]
